import { goRequest } from '../utils/httpClientTs';
import {
  LoginResponse,
  Credentials,
  PasswordResetRequest,
  PasswordResetResponse,
  PasswordResetConfirm,
  PasswordResetComplete,
  ChangePasswordRequest,
  ChangePasswordResponse,
  SetTempPasswordResponse,
} from '../types/auth';

export const login = (data: Credentials): Promise<LoginResponse> =>
  goRequest({
    url: '/auth/login',
    method: 'POST',
    data,
  });

export const logout = (): Promise<void> =>
  goRequest({
    url: '/auth/logout',
    method: 'POST',
    data: { refresh_token: localStorage.getItem('refresh') },
  });

export const getMe = (): Promise<any> =>
  goRequest({
    url: '/auth/refresh',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('refresh')}`,
    },
  });

export const getForgotPassword = (
  data: PasswordResetRequest
): Promise<PasswordResetResponse> =>
  goRequest({
    url: '/auth/password-reset/request',
    method: 'POST',
    data,
  });

export const getResetPassword = (data: PasswordResetConfirm): Promise<any> =>
  goRequest({
    url: '/auth/password-reset/confirm?token=' + data.token,
    method: 'GET',
  });

export const updatePassword = (
  data: PasswordResetComplete
): Promise<PasswordResetResponse> =>
  goRequest({
    url: '/auth/password-reset/complete',
    method: 'POST',
    data,
  });

export const changePassword = (
  data: ChangePasswordRequest
): Promise<ChangePasswordResponse> =>
  goRequest({
    url: '/auth/change-password',
    method: 'POST',
    data,
  });

export const setTempPassword = (
  userId: string
): Promise<SetTempPasswordResponse> =>
  goRequest({
    url: `/users/${userId}/set-temp-password`,
    method: 'POST',
  });
